'use strict';

function SystemStatusInterfaceStatusSearchService() {
  function getEventFrequencies() {
    return ['Hourly', 'Daily', 'Weekly', 'Monthly'];
  }
  function getEventDirections() {
    return ['Input', 'Output'];
  }
  return {
    getEventFrequencies: getEventFrequencies,
    getEventDirections: getEventDirections
  };
}
SystemStatusInterfaceStatusSearchService.$inject = [];
module.exports = SystemStatusInterfaceStatusSearchService;